import { stop } from './stop';
import { create } from './create';
import { edit } from './edit';
import { list } from './list';

export const scenes = {
    stop,
    create,
    edit,
    list,
};
